import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import createMemoizedSelector from 'redux/selectors/createMemoizedSelector';
var getHasModality = function getHasModality(modality) {
  return function (state) {
    var _state$info$modalitie;
    return ((_state$info$modalitie = state.info.modalities) !== null && _state$info$modalitie !== void 0 ? _state$info$modalitie : []).includes(modality);
  };
};
export default createMemoizedSelector(getHasModality);